<div class="home-background-container">
	<div class="home-background-fade">
	    <div class="home-frame">
	            <div class="jumbotron jumbotron-fluid">
	
	                  <div class="d-flex flex-wrap">
	                    <h1 role="heading">{{ 'home.news.title' | translate }}</h1>
	                  </div>
	
	            </div>
	    </div>
    </div>
</div>
